import { Link } from 'react-router-dom';
import Button from "../../../components/base/Button.tsx";
export function DropInPassesSection() {
  const passes = [
    {
      title: 'DROP-IN',
      price: '$25',
      features: [
        'Limited to 1 class participation'
      ],
      buttonText: 'Buy Now'
    },
    {
      title: '5 CLASSES PASS',
      price: '$109',
      features: [
        'Unlimited access to 5 group classes',
        '3 months expiration'
      ],
      buttonText: 'Buy Now'
    },
    {
      title: '10 CLASSES PASS',
      price: '$209',
      features: [
        'Unlimited access to 10 group classes',
        '6 months expiration'
      ],
      buttonText: 'Buy Now'
    }
  ];

  return (
    <section className="py-8">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-[#00889D] mb-4 md:mb-12">Drop In & Punch Passes</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {passes.map((pass, index) => (
            <div key={index} className="price-box bg-white rounded-2xl border-2 border-gray-200 p-8 shadow-lg flex flex-col">
              {/* Header with title and price */}
              <div className="title flex justify-between items-start mb-6">
                <div className="text-[#00889D] font-bold text-lg">{pass.title}</div>
                <div className="text-4xl font-bold text-[#00889D]">{pass.price}</div>
              </div>
              
              {/* Features list */}
              <div className="space-y-3 mb-8 flex-grow">
                {pass.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-start">
                    <i className="ri-check-line text-[#00889D] mr-3 text-xl mt-0.5 flex-shrink-0"></i>
                    <span className="text-gray-700 text-left">{feature}</span>
                  </div>
                ))}
              </div>

              <Link to="/buy-now" className="block w-full py-4 px-6 rounded-lg text-white font-semibold whitespace-nowrap cursor-pointer bg-[#00889D] hover:bg-[#007089] text-lg text-center">
                {pass.buttonText}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
